import script from "./FormGeneralComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormGeneralComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormGeneralComponent.vue?vue&type=style&index=0&id=17eb5e58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17eb5e58"]])

export default __exports__